import styled from 'styled-components';

export const SocialIconsContainer = styled.div`
  display: flex;
  flex-direction: row;

  /* "trims" excess image whitespace */
  margin-left: -11px;

  > * + * {
    margin-left: 12px;
  }
`;
